import script from "./Autocomplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./Autocomplete.vue?vue&type=script&setup=true&lang=ts"

import "./Autocomplete.vue?vue&type=style&index=0&id=398f2066&lang=scss"

const __exports__ = script;

export default __exports__